"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.migration_34_0_0 = void 0;
const ManagedConfigurationType_1 = require("../ManagedConfigurationType");
/**
 * Migrate to 34.0.0
 *
 * The property `managedConfigurationType` has been added to `Configuration`.
 *
 *  =>
 *
 *  set this property to `IQuote` by default as iQuote is already live in production.
 */
const migration_34_0_0 = (json) => {
    if (!json.ManagedConfigurationType) {
        json.ManagedConfigurationType = ManagedConfigurationType_1.ManagedConfigurationType.IQuote;
    }
    return json;
};
exports.migration_34_0_0 = migration_34_0_0;
//# sourceMappingURL=migration_34_0_0.js.map